interface DotGridProps {
  className?: string;
  fade?: "top" | "bottom" | "radial" | "none";
  size?: "default" | "sm";
  tone?: "auto" | "light";
}

/**
 * Subtle Fluent-style dot grid background pattern.
 * Use as absolutely-positioned overlay inside a relative section.
 * Set tone="light" when placing on a dark surface.
 */
export const DotGrid = ({ className = "", fade = "radial", size = "default", tone = "auto" }: DotGridProps) => {
  const fadeStyle =
    fade === "top"
      ? { maskImage: "linear-gradient(to bottom, black, transparent)" }
      : fade === "bottom"
      ? { maskImage: "linear-gradient(to top, black, transparent)" }
      : fade === "radial"
      ? { maskImage: "radial-gradient(ellipse 70% 50% at 50% 50%, black, transparent)" }
      : undefined;

  const patternClass =
    tone === "light"
      ? "bg-dot-grid-light"
      : size === "sm"
      ? "bg-dot-grid-sm"
      : "bg-dot-grid";

  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 ${patternClass} ${className}`}
      style={fadeStyle as React.CSSProperties}
    />
  );
};
